import React, { useState} from "react";
import Calendar from "../../components/Calendar/Calendar";
import { formateDate } from "../../utils/utils"
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
const DateRange = ({
  applyDateRange,
  onCancel,  

}) => {
  const [showByDateRangeFrom, setDateRangeFrom] = useState(false);
  const [showByDateRangeTo, setDateRangeTo] = useState(false);
  const [startTimestamp, setStartTimeStamp] = useState('');
  const [endTimestamp, setEndTimestamp] = useState(''); 
  
  return (
    <div className="duration-sec-wrapper">
    <div
      className={`dateRangeSec ${startTimestamp && endTimestamp && "selected"
        }`}
    // onClick={() => {
    //   setSelectedFilter(null);
    // }}
    >
      <label className="date-range-text">Date Range</label>
      <div className="date-input-row">
        <div className="circle line"></div>
        <label>From</label>
        <div
          className="input-box"
          onClick={() => {
            setDateRangeFrom(true);
            setDateRangeTo(false);
          }}
        >
          <span
            className={`date-value ${startTimestamp ? "active" : ""
              }`}
          >
            {startTimestamp
              ? formateDate(new Date(startTimestamp))
              : "DD/MM/YYYY"}
          </span>
          <span className="calendar_icon"></span>
        </div>
      </div>
      <div className="date-input-row">
        <div className="circle"></div>
        <label>To</label>
        <div
          className="input-box"
          onClick={() => {
            setDateRangeTo(true);
            setDateRangeFrom(false);
          }}
        >
          <span
            className={`date-value ${endTimestamp ? "active" : ""
              }`}
          >
            {endTimestamp
              ? formateDate(new Date(endTimestamp))
              : "DD/MM/YYYY"}
          </span>
          <span className="calendar_icon"></span>
        </div>
      </div>
      {startTimestamp && endTimestamp && (
                <div className="date-range-apply-btn">
                  <button
                    onClick={() => {
                      applyDateRange(formateDate(new Date(startTimestamp),'-'),formateDate(new Date(endTimestamp),'-'));
                     // showSelectedMobilePopUp();
                    }}
                  >
                    Apply
                  </button>
                </div>
              )}
    </div>
    {showByDateRangeFrom && (
      <MobilePopUp
        hideCloseBtn={true}
        removeHeader={true}
        cssClass="daterange-mobilepopup"
      >
        <Calendar
          dob={startTimestamp}
          maxDate={endTimestamp ? endTimestamp : new Date()}
          onCancel={() => {
            setDateRangeFrom(false);
            //showSelectedMobilePopUp(true);
            setStartTimeStamp("");
          }}
          onApply={(sd) => {
            setDateRangeFrom(false);
            //showSelectedMobilePopUp(true);
            setStartTimeStamp( sd);
          }}
        />
      </MobilePopUp>
    )}
    {showByDateRangeTo && (
      <MobilePopUp
        hideCloseBtn={true}
        removeHeader={true}
        cssClass="daterange-mobilepopup"
      >
        <Calendar
          dob={endTimestamp}
          minDate={startTimestamp}
          maxDate={new Date()}
          onCancel={() => {
            setDateRangeTo(false);
           // showSelectedMobilePopUp(true);
           setEndTimestamp("");
          }}
          onApply={(sd) => {
            setDateRangeTo(false);
            //showSelectedMobilePopUp(true);
            setEndTimestamp(sd);
          }}
        />
      </MobilePopUp>
    )}</div>);
};

export default DateRange;
